import { render, staticRenderFns } from "./ProcessSettlementModal.vue?vue&type=template&id=2cb45027&scoped=true"
import script from "./ProcessSettlementModal.vue?vue&type=script&lang=js"
export * from "./ProcessSettlementModal.vue?vue&type=script&lang=js"
import style0 from "./ProcessSettlementModal.vue?vue&type=style&index=0&id=2cb45027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb45027",
  null
  
)

export default component.exports